var _rect, _g, _g2, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _rect3, _ellipse2, _g3, _line, _line2, _line3, _line4, _line5, _line6, _circle, _rect4, _rect5, _rect6, _rect7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenderBid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 132,
    viewBox: "0 0 140 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 116,
    height: 115,
    rx: 57.5,
    fill: "#FCE9DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_8307_128895)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.5801,
    height: 58.5189,
    rx: 8,
    transform: "matrix(0.936915 -0.349557 0.350408 0.936597 20.1738 57.6211)",
    fill: "url(#paint0_linear_8307_128895)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 31.9062,
    y: 54.1211,
    width: 58.4355,
    height: 58.3633
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_8307_128895_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_8307_128895)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.9062,
    y: 58.1211,
    width: 50.4348,
    height: 50.365,
    rx: 8,
    fill: "white",
    fillOpacity: 0.31
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3926,
    y: 66.8633,
    width: 9.55571,
    height: 15.1233,
    transform: "rotate(40.4345 64.3926 66.8633)",
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7272 81.1029L77.6606 91.9013C77.9646 92.1552 78.3157 92.3468 78.6937 92.4651C79.0717 92.5833 79.4693 92.626 79.8638 92.5906C80.6606 92.5191 81.3963 92.134 81.9091 91.5201C82.422 90.9061 82.6699 90.1136 82.5984 89.3169C82.5269 88.5201 82.1418 87.7844 81.5279 87.2716L68.5901 76.4722",
    fill: "#FAFAFA",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2773 85.6052L53.0181 77.8736L62.2773 85.6052Z",
    fill: "#FAFAFA",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7897 78.5179L64.0985 66.1723L53.7897 78.5179Z",
    fill: "#FAFAFA",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5861 73.2596L63.3269 65.528L72.5861 73.2596Z",
    fill: "#FAFAFA",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8145 72.6153L61.5057 84.9609L71.8145 72.6153Z",
    fill: "#FAFAFA",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7272 81.1029L77.6606 91.9013C77.9646 92.1552 78.3157 92.3468 78.6937 92.4651C79.0717 92.5833 79.4693 92.626 79.8638 92.5906C80.6606 92.5191 81.3963 92.134 81.9091 91.5201C82.422 90.9061 82.6699 90.1136 82.5984 89.3169C82.5269 88.5201 82.1418 87.7844 81.5279 87.2716L68.5901 76.4722M62.2773 85.6052L53.0181 77.8736M53.7897 78.5179L64.0985 66.1723M72.5861 73.2596L63.3269 65.528M71.8145 72.6153L61.5057 84.9609",
    stroke: "#FCFCFC",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 93,
    rx: 14,
    ry: 4,
    fill: "#FAFAFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 88.9961,
    width: 22,
    height: 6,
    fill: "#FAFAFA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 88.9961,
    rx: 11,
    ry: 3,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8307_128895)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 5,
    width: 58.3294,
    height: 37,
    rx: 5,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.25,
    y: 5.25,
    width: 57.8294,
    height: 36.5,
    rx: 4.75,
    stroke: "#EFEFEF",
    strokeWidth: 0.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.7891,
    y1: 10.0938,
    x2: 122.189,
    y2: 10.0938,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 77.7891,
    y1: 14.8828,
    x2: 120.448,
    y2: 14.8828,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 77.7891,
    y1: 19.6719,
    x2: 113.918,
    y2: 19.6719,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81.2695,
    y1: 28.8789,
    x2: 110.87,
    y2: 28.8789,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 81.2695,
    y1: 31.9219,
    x2: 110.87,
    y2: 31.9219,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 81.2695,
    y1: 34.9688,
    x2: 110.87,
    y2: 34.9688,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.194,
    cy: 8.70152,
    r: 1.08824,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.047,
    y: 34.1641,
    width: 13.0588,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.047,
    y: 28.5078,
    width: 3.91765,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 117.617,
    y: 28.5078,
    width: 3.91765,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 122.188,
    y: 28.5078,
    width: 3.91765,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_8307_128895",
    x: 6.46875,
    y: 27.4336,
    width: 102.801,
    height: 102.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8307_128895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8307_128895",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_8307_128895"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_8307_128895",
    result: "effect3_innerShadow_8307_128895"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_8307_128895",
    x: 31.9062,
    y: 54.1211,
    width: 58.4355,
    height: 58.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8307_128895"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_8307_128895",
    result: "effect2_innerShadow_8307_128895"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_8307_128895_clip_path",
    transform: "translate(-31.9062 -54.1211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.9062,
    y: 58.1211,
    width: 50.4348,
    height: 50.365,
    rx: 8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8307_128895",
    x: 65,
    y: 0,
    width: 74.3301,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8307_128895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8307_128895",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8307_128895",
    x1: 29.2901,
    y1: 0,
    x2: 29.2901,
    y2: 58.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1935C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9631F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderBid);
export default __webpack_public_path__ + "static/media/TenderBid.3ca711af7a30dfec46cb3ad811641b1d.svg";
export { ForwardRef as ReactComponent };